import { pulse } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

export const imagePlaceholder = css`
  background-color: var(--neutral-black-30);
  ${pulse};
`;
